var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7717 10.0377H5.32827C4.26761 10.0377 3.40778 10.8976 3.40778 11.9582V19.6402C3.40778 20.7008 4.26761 21.5607 5.32827 21.5607H18.7717C19.8324 21.5607 20.6922 20.7008 20.6922 19.6402V11.9582C20.6922 10.8976 19.8324 10.0377 18.7717 10.0377Z",
    stroke: "#3D64E3",
    strokeWidth: 2.56066
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28851 6.19678C6.28851 5.43276 6.59202 4.70003 7.13226 4.15979C7.67251 3.61955 8.40523 3.31604 9.16925 3.31604H14.9307C15.6948 3.31604 16.4275 3.61955 16.9677 4.15979C17.508 4.70003 17.8115 5.43276 17.8115 6.19678V10.0378H6.28851V6.19678Z",
    stroke: "#3D64E3",
    strokeWidth: 2.56066
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.bb83bf67358699860969e9a41e713924.svg";
export { ForwardRef as ReactComponent };